@if (commands && commands.length > 0) {
  <div flexLayout="row wrap" flexLayoutGap="10px">
    @for (command of commands; track command) {
      <button
        type="button"
        class="btn-command"
        mat-stroked-button
        color="primary"
        matTooltip="{{ command.description }}"
        (click)="sendAdvancedCommand(command)"
        >
        {{ command.displayName }}
      </button>
    }
  </div>
}
@if (commands?.length === 0) {
  <div>No Commands Are Available</div>
}
